import { OperationElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Operation extends OperationElement {
  // OpenAPI 3.2 does not introduce new fields to Operation.
  // The requestBody field already exists in OpenAPI 3.1.
}
export default Operation;